import { format, getZonedDate } from '@eika-infrastruktur/date';
import { IconTypes } from '@eika/icon';
import { LabelTypes } from '@eika/label';

import TranslationsConfigType from '../../../translations/translationType';
import { DueType } from './useIsDue';

const today = getZonedDate();
export const labelDateFormat = 'd. MMMM';
export const labelDateFormatYear = 'd. MMMM yyy';

export const formatDate = (date: Date): string => {
    const year = today.getFullYear();
    if (year !== date.getFullYear()) {
        return format(date, labelDateFormatYear);
    }
    return format(date, labelDateFormat);
};

export const getDueDateLabelTypeAndIcon = (dueType: DueType | null): { type: LabelTypes; icon?: IconTypes } => {
    switch (dueType) {
        case 'overdue':
            return { type: 'error', icon: IconTypes.UTROPSTEGN_24 };
        case 'today':
            return { type: 'inverted' };
        default:
            return { type: 'warning' };
    }
};

export const getDueDateLabel =
    (translated: TranslationsConfigType) => (dueType: DueType | null, paymentDate: string) => {
        const date = getZonedDate(paymentDate);
        const formattedDate = formatDate(date);

        switch (dueType) {
            case 'today':
                return translated.approvalItem.overdueToday;
            case 'overdue':
                return `${translated.approvalItem.overdue} ${formattedDate}`;
            default:
                return `${translated.approvalItem.deadline} ${formattedDate}`;
        }
    };
